import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted, {"position":"bottom-right","className":"opsy-toast","duration":5000,"iconPack":"mdi","action":{"icon":"mdi-close-circle","onClick":(e, toastObject) => {
      toastObject.goAway(0);
    }}})

const globals = undefined
if(globals) {
  globals.forEach(global => {
    Vue.toasted.register(global.name, global.message, global.options)
  })
}

export default function (ctx, inject) {
  inject('toast', Vue.toasted)
}
